module.exports = __webpack_public_path__ + "img/github-2.c654b44a.svg";